import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const rebuildCopResolution = api(async function rebuildCopResolution({ id }) {
    return mutate(
        gql`
            mutation RebuildCopResolution($id: ID!) {
                rebuildCopResolution(id: $id)
            }
        `,
        { id },
        { returns: "rebuildCopResolution" }
    )
})
